"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var ProjectTypeInput = /** @class */ (function (_super) {
    __extends(ProjectTypeInput, _super);
    function ProjectTypeInput(props) {
        var _this = _super.call(this, props) || this;
        var hasProjectType = !!_this.props.worklog.projectType;
        var lastWorkLogId = _this.props.lastWorkLogId;
        var showInput = !hasProjectType || _this.props.worklog._id === lastWorkLogId;
        _this.state = { showInput: showInput };
        return _this;
    }
    ProjectTypeInput.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.lastWorkLogId !== nextProps.lastWorkLogId) {
            var hasProjectType = !!nextProps.worklog.projectType;
            var lastWorkLogId = nextProps.lastWorkLogId;
            var showInput = !hasProjectType || nextProps.worklog._id === lastWorkLogId;
            this.setState({ showInput: showInput });
        }
    };
    ProjectTypeInput.prototype.componentDidMount = function () {
        if (this.state.showInput) {
            this.selectInput.focus();
        }
    };
    ProjectTypeInput.prototype.renderType = function () {
        var _this = this;
        return (React.createElement("span", { className: "clickable", onClick: function () { return _this.onFocus(); } }, this.props.worklog.projectType && this.props.worklog.projectType.name));
    };
    ProjectTypeInput.prototype.onTypeUpdated = function (typeCode) {
        var selectedType = this.props.projectTypes
            .find(function (subType) { return subType.code.toString() === typeCode; });
        if (!selectedType) {
            return;
        }
        this.props.onProjectTypeChanged(selectedType);
    };
    ProjectTypeInput.prototype.onBlur = function () {
        var currentProjectType = this.props.worklog.projectType;
        currentProjectType && this.setState({ showInput: false });
    };
    ProjectTypeInput.prototype.onFocus = function () {
        var _this = this;
        this.setState({ showInput: true }, function () {
            _this.selectInput.focus();
        });
    };
    ProjectTypeInput.prototype.renderInput = function () {
        var _this = this;
        var currentProjectType = this.props.worklog.projectType;
        return (React.createElement("select", { name: "subtypeCode", onBlur: function () { return _this.onBlur(); }, value: currentProjectType && currentProjectType.code || '0', onChange: function (event) { return _this.onTypeUpdated(event.target.value); }, ref: function (ref) { _this.selectInput = ref; } },
            !currentProjectType && React.createElement("option", { value: 0 }),
            this.props.projectTypes.map(function (type) {
                return React.createElement("option", { key: type.code, value: type.code.toString() }, type.name);
            })));
    };
    ProjectTypeInput.prototype.render = function () {
        return (React.createElement("div", { className: "subTypeInput" }, this.state.showInput ? this.renderInput() : this.renderType()));
    };
    return ProjectTypeInput;
}(React.Component));
var mapStateToProps = function (_) {
    return {
        lastWorkLogId: _.reducer.WeekDaysReducer.lastWorkLogId,
    };
};
var mergeProps = function (stateProps, dispatchProps, ownProps) {
    return __assign(__assign(__assign({}, stateProps), dispatchProps), ownProps);
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, null, mergeProps)(ProjectTypeInput);
